import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RecetaLista from "./RecetaLista";
import { obtenerResumenRecetas, obtenerRecetaPorIdDirecto } from "../../../services/recetas"; // Importamos axios
import "./DashboardRecetas.css";
import { API_URL } from "../../../services/config"; 
import { toast } from "react-toastify";

const DashboardRecetas = () => {
  const [vista, ] = useState("lista"); 
  const [busqueda, setBusqueda] = useState("");
  const [recetas, setRecetas] = useState([]);
  const navigate = useNavigate();

  // 🔹 Cargar recetas desde `db.json`
  useEffect(() => {
    const cargarRecetas = async () => {
      const recetasObtenidas = await obtenerResumenRecetas();
      setRecetas(recetasObtenidas);
    };
    cargarRecetas();
  }, []);  // 

  const handleAbrirReceta = async (receta) => {
  // 1) Si está firmada → descarga directa desde S3
  if (receta.es_firmada) {
    window.open(`${API_URL}recetas/${receta.id}/descargar_firmada/`, "_blank");
    return;
  }

  // 2) Si NO está firmada → flujo normal
  try {
    const recetaCompleta = await obtenerRecetaPorIdDirecto(receta.id);
    navigate("/dashboard/recetas/formulario", { state: { receta: recetaCompleta } });
  } catch (error) {
    toast.error("No se pudo cargar la receta. Intenta de nuevo.");
  }
};

  // 🔹 Filtrar recetas por nombre
  const recetasFiltradas = recetas
    .filter((receta) =>
      receta.nombrePaciente.toLowerCase().includes(busqueda.toLowerCase())
    )
    .sort((a, b) => new Date(b.fecha) - new Date(a.fecha)) // Orden descendente

  return (
    <div className="recetas-container">
      <h2>Recetas Electrónicas</h2>

      {vista === "lista" && (
        <>
          {/* Buscador */}
           <button className="top-receta-button" onClick={() => {
            navigate("/dashboard/recetas/formulario",  { state: { receta: null } }); // ✅ También redirige al formulario vacío
          }}>
            Crear Nueva Receta
          </button>
          
            <input
              type="text"
              placeholder="Buscar por nombre del paciente"
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
            />
          
          {/* Lista de recetas */}
         <RecetaLista
          recetas={recetasFiltradas}
          onAbrirReceta={handleAbrirReceta}
        />
        </>
      )}
    </div>
  );
};

export default DashboardRecetas;
